import GenerateProducts from './GenerateProducts';

export default GenerateProducts;
